import styled from 'styled-components';

const StyledLogo = styled.img`
  width: 48px;
  pointer-events: none;
`;

export default StyledLogo;
